import SplashScreen from "@/types/components/SplashScreen.interface"

interface State {
    splash: SplashScreen
}

const defaults = () => ({
    splash: null
})

export default {
    state: defaults(),
    mutations: {
        splashSet(state: State, splash: SplashScreen): void {
            state.splash = splash
        }
    },
    getters: {
        splash (state: State): SplashScreen {
            return state.splash
        }
    }
}
